import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Button, Page, Msg, LoadMore, Toast, Panel, Dialog } from 'react-weui';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import PropTypes from 'prop-types';
import { formatDate } from 'lib/formatter';
import Http from 'services/http2';
import User from 'services/user2';
import EnumService from 'services/enum2';
import CompanyService from 'services/company2';
import TopNav from 'components/topNav';
import DeliveryToReceive from 'components/deliveryToReceive.js';
import * as MobileActions from '../actions/index.ts';
import CommonFns from 'functions/common.ts';
import Util from 'lib/util.js';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import CropFreeIcon from '@material-ui/icons/CropFree';
import * as dd from 'dingtalk-jsapi'; // 此方式为整体加载，也可按需进行加载

/**
 * 采购收货列表
 *
 * 扫码收货/入库
 *
 *
 */

/* dev
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fpurchase%2Freceive%2Flist&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/
const Config = {
  receive: {
    apiPath: '/receiveOrder/list',
    orderProperty: 'createTime',
    enumMainKey: 'B02_Ro_Status',
    docNumKey: [],
    detailLink: '/mp/purchase/receive/detail',
    searchBarPlaceholder: '供应商名称/编码、收货单号、商品名称/编码/规格',
  },
  storage: {
    apiPath: '/storageOrder/list',
    orderProperty: 'createTime',
    enumMainKey: 'B02_Sto_Status',
    docNumKey: ['', 'roXkNo', 'dnXkNo', 'vfoXkNo'], //对应sourceOrderType
    detailLink: '/mp/purchase/storage/detail',
    searchBarPlaceholder: '供应商名称/编码、入库单号、商品名称/编码/规格',
  },
};

class ReceiveList extends Component {
  constructor(props) {
    super(props);
    this.reset = false;
    this.companyCode = '';
    this.pageNum = 1;
    this.searchKey = '';
    this.searchQueries = { dnXkNo: '', sourceOrderNo: '' };
    this.total = 0;
    this.handleClear = this.handleClear.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.handleConvertChange = this.handleConvertChange.bind(this);
    this.delivery = this.delivery.bind(this);
    this.hideDialog = this.hideDialog.bind(this);
    this.errorFn = this.errorFn.bind(this);
    this.scan = this.scan.bind(this);
    this.handleNotSync = this.handleNotSync.bind(this);
    this.config = Config['receive'];
    this.isReady = false;
    // 引用InfiniteLoader中resolveLoading方法，用于重置列表加载状态
    this.resolveLoading = () => {};
    // this.currNavIndex = 0;
    this.tabData = [
      {
        label: '收货单', //采购收货单
        navIndex: 0,
      },
      {
        label: '入库单', //采购入库单
        navIndex: 1,
      },
      {
        label: '待发布', //待发布（收货）
        navIndex: 4,
        countIndex: 'receiveUnPublish',
        show: () => this.state.canReceive,
      },
      {
        label: '待发布', //待发布（入库）
        navIndex: 41,
        countIndex: 'storageUnPublish',
        show: () => this.state.canStorage,
      },
    ];
    this.dialogMsg = '';
    this.state = {
      error: null,
      list: [],
      count: [],
      dnXkNo: '',
      sourceOrderNo: '',
      companyCode: null,
      currNavIndex: 0,
      billType: null, //单别: 2 收货 3入库
      canReceive: false, //是否可转收货
      canStorage: false, //是否可转入库
      canRreateIqcOrder: false, //是否可以新建检验单
      dnDetail: {},
      showLoading: true,
      showSuccess: false,
      isShowSearch: false,
      wxReady: false, // 是否允许移动扫码
      style2: {
        title: '',
        buttons: [
          {
            type: 'default',
            label: '取消',
            onClick: this.hideDialog.bind(this),
          },
          {
            type: 'primary',
            label: '确认',
            onClick: this.handleOrder.bind(this),
          },
        ],
      },
      onlyShowNotSync: false, //仅显示未同步
    };
    this.currItem = {};
  }

  // let { state, dispatch } = useContext(ActionContext);

  async init() {
    User.init().then(async response => {
      if (response.success) {
        this.setState({ inited: true });
        this.companyCode = User.getCompanyCode();
        this.setState({ companyCode: this.companyCode });
        await this.getCompanyParams();
        this.getList();
        this.getCount();
        this.isReady = true;
      } else {
        this.setState({
          error: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  componentDidMount() {
    this.init().then(() => {
      // let appName = User.getAppName();
      // User.sendEvent({ fn: 'receiveList init', appName: appName });
      // if (appName === 'dingtalk') {
      //   this.setState({ wxReady: true });
      //   return;
      // }
    });
    if (dd.env.platform !== 'notInDingTalk') {
      // 在钉钉环境内执行扫码逻辑
      this.setState({ wxReady: true });
      return;
    }
    this.initWx();
  }

  /** 扫码收货 begen */

  initWx() {
    const userAgent = window.navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);

    //IOS暂不支持扫码
    if (isIOS) {
      return;
    }
    let wx = window.wx;
    let url = window.location.href.split('#')[0];
    Http.post('/api/mp', { url, apiPath: '/initJsapi' }).then(rs => {
      if (rs.success) {
        let data = rs.data;
        if (!data.appId) {
          this.setState();
          return;
        }
        wx.config({
          ...data,
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          jsApiList: ['scanQRCode', 'chooseImage', 'getNetworkType'], // 必填，需要使用的JS接口列表
        });
        wx.ready(() => {
          this.setState({ wxReady: true });
        });
        wx.error(function (res) {
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        });
      }
    });
  }

  // 钉钉扫码
  dingScan() {
    let getDnXkNo = async code => {
      let dnXkNo = await this.getDnXkNo(code);
      if (dnXkNo) {
        this.getDnDetail(dnXkNo);
      }
    };

    dd.ready(function () {
      dd.biz.util.scan({
        type: 'all', // type 为 all、qrCode、barCode，默认是all。
        onSuccess: function (data) {
          // 获取送货单号
          getDnXkNo(data.text);
        },
        onFail: function (err) {
          // alert(JSON.stringify(err));
        },
      });
    });
  }
  scan() {
    if (dd.env.platform !== 'notInDingTalk') {
      // 在钉钉环境内执行扫码逻辑
      this.dingScan();
      return;
    }

    let wx = window.wx;

    let getDnXkNo = async code => {
      let dnXkNo = await this.getDnXkNo(code);
      if (dnXkNo) {
        this.getDnDetail(dnXkNo);
      }
    };

    wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      success: function (res) {
        //一维码：{reultStr: 'code128,abcd123', errMsg: 'scanQRCode:ok'}
        //二维码：{reultStr: 'abcd123', errMsg: 'scanQRCode:ok'}
        let result = res.resultStr;
        let arrCode = result.split(',');
        let code = arrCode[arrCode.length - 1];

        // 获取送货单号
        getDnXkNo(code);
      },
      fail: function (res) {
        // alert(JSON.stringify(res));
      },
    });
  }

  /**
   * 获取送货单号
   *
   * @param code 扫码结果，送货单号或物流单号
   */
  async getDnXkNo(code) {
    let postbody = {
      companyCode: this.companyCode,
      dnXkNo: code,
      apiPath: '/vdeliveryNotice/getDnXkNo',
    };
    let dnXkNo;
    this.setState({ showLoading: true });
    await Http.post('/api/cloudCenter', postbody).then(response => {
      this.setState({ showLoading: false });
      if (response.success) {
        dnXkNo = response.data;
      } else {
        this.setState({
          dataError: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
    return dnXkNo;
  }

  // 钉钉扫码搜索
  dingDelivery() {
    let linkTo = code => {
      let url =
        '/mp/purchase/vendorDelivery/detail/' + this.companyCode + '/' + code;
      this.props.history.push(url);
    };

    dd.ready(function () {
      dd.biz.util.scan({
        type: 'all', // type 为 all、qrCode、barCode，默认是all。
        onSuccess: function (data) {
          // 获取送货单号
          linkTo(data.text);
        },
        onFail: function (err) {
          // alert(JSON.stringify(err));
        },
      });
    });
  }

  // 扫码搜索
  delivery() {
    if (dd.env.platform !== 'notInDingTalk') {
      // 在钉钉环境内执行扫码逻辑
      this.dingDelivery();
      return;
    }

    let wx = window.wx;
    let linkTo = code => {
      let url =
        '/mp/purchase/vendorDelivery/detail/' + this.companyCode + '/' + code;
      this.props.history.push(url);
    };
    wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      success: function (res) {
        //一维码：{reultStr: 'code128,abcd123', errMsg: 'scanQRCode:ok'}
        //二维码：{reultStr: 'abcd123', errMsg: 'scanQRCode:ok'}
        let result = res.resultStr;
        let arrCode = result.split(',');
        let code = arrCode[arrCode.length - 1];
        linkTo(code);
      },
      fail: function (res) {
        // alert(JSON.stringify(res));
      },
    });
  }

  /**
   *  获取送货单详情
   *
   */
  getDnDetail(dnXkNo) {
    let postbody = {
      companyCode: this.companyCode,
      dnXkNo,
      apiPath: '/vdeliveryNotice/getDetail',
    };
    this.setState({ showLoading: true });
    Http.post('/api/cloudCenter', postbody).then(response => {
      this.setState({ showLoading: false });
      if (response.success) {
        this.setState({ dnDetail: response.data });
        this.checkDnStatus(this.state.dnDetail);
      } else {
        this.setState({
          dataError: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  //检查是否有转收货/入库的权限
  checkDnStatus(detail) {
    let errorMsg;
    let text = this.state.currNavIndex === 0 ? '转收货单' : '转入库单';
    if (detail.id === undefined) {
      errorMsg = '无送货单信息';
    } else if (detail.deliveryType === 2) {
      errorMsg = '补送货单不能' + text;
    } else if (detail.convertStatus === 2) {
      errorMsg = '此送货单已' + text;
    } else if (![1, 2].includes(detail.status)) {
      errorMsg = '送货单状态不是待签收或签收中';
    } else if ([1, 2].includes(detail.multiRelationRoleType)) {
      errorMsg = '多角送货单无法' + text;
    }
    if (errorMsg) {
      this.setState({
        dataError: {
          type: 'warn',
          title: errorMsg,
        },
      });
    } else {
      const { actions } = this.props;
      actions.openStockInModal();
    }
  }

  //获取企业参数(开启缓存)
  async getCompanyParams() {
    await CompanyService.getCompanyParamsByCodes(
      [this.companyCode],
      [
        'Use_platform_recieve_process',
        'Use_platform_verify_process',
        'Use_recieve_order_down_erp',
      ],
      true
    ).then(data => {
      let companyParams = {};
      data.forEach(row => {
        companyParams[row.paramCode] =
          row.paramType === 1 ? row.paramValue : row.paramValue === '1';
      });
      let recieveProcess = companyParams['Use_platform_recieve_process'];
      let verifyProcess = companyParams['Use_platform_verify_process'];
      let recieveDownErp = companyParams['Use_recieve_order_down_erp'];

      /*
       * 是否可转收货单。启用平台收货流程，下传ERP是收货单
       */
      this.setState({
        canReceive:
          User.checkAuth('10030203') &&
          recieveProcess &&
          recieveDownErp === '1',
      });

      /*
       * 是否可转入库单。启用平台收货流程，下传ERP是入库单
       */
      this.setState({
        canStorage:
          User.checkAuth('10030203') &&
          recieveProcess &&
          recieveDownErp === '2',
      });

      /*
       * 启用平台收货流程，启用来料检验、且下传ERP是收货单，收货单可转检验/展示检验相关字段
       */
      this.setState({
        canRreateIqcOrder:
          recieveProcess && verifyProcess && recieveDownErp === '1',
      });

      //设置转换单别
      if (User.checkAuth('10030203') && recieveProcess) {
        this.setState({ billType: recieveDownErp === '1' ? 2 : 3 });
      }

      // 默认显示入库单
      if (recieveProcess && recieveDownErp === '2') {
        this.status = undefined;
        this.config = Config['storage'];
        this.setState({ billType: 3, currNavIndex: 1 });
      }
    });
  }

  //转收货/入库完成
  handleConvertChange(data) {
    if (Array.isArray(data)) {
      this.setState({ showSuccess: true });

      setTimeout(() => {
        this.setState({ showSuccess: false });
        if (data.length > 1) {
          this.handleReset();
        } else if (data[0]) {
          let url =
            this.state.billType === 2
              ? '/mp/purchase/receive/detail/'
              : '/mp/purchase/storage/detail/';
          this.props.history.push(url + this.state.companyCode + '/' + data[0]);
        }
      }, 2000);
    }
  }

  /** 扫码收货 end */

  getList(cb = () => {}) {
    let enumMainKey = this.config.enumMainKey;
    let onlyShowNotSync = this.state.onlyShowNotSync;
    let postbody = {
      apiPath: this.config.apiPath,
      status: onlyShowNotSync ? [] : this.status,
      diffStatus: this.diffStatus,
      companyCode: this.companyCode,
      searchKey: this.searchKey,
      dnXkNo: this.searchQueries.dnXkNo.trim(),
      sourceOrderNo: this.searchQueries.sourceOrderNo.trim(),
      orderProperty: this.config.orderProperty || 'createTime',
      ascOrDesc: 'desc',
      pageSize: 10,
      pageNum: this.pageNum,
      syncStatusArray: onlyShowNotSync ? [1, 3] : undefined,
    };
    let arrPromise = [
      Http.post('/api/cloudCenter', postbody),
      EnumService.getList(enumMainKey),
      EnumService.getList('B02_Dn_Logistics_Status'),
      EnumService.getList('B02_Dn_Type'),
    ];
    this.setState({ dataError: null });
    Promise.all(arrPromise).then(arrResponse => {
      let response = arrResponse[0];
      this.reset = false;
      this.setState({ showLoading: false });
      if (response.success) {
        let list = response.data.list || [];
        this.setState({ list: this.state.list.concat(list) }, () => cb());
        this.pageNum += 1;
        this.total = response.data.total;
        this.state.list.forEach((item, index) => {
          if (item.statusName === undefined) {
            EnumService.getValue(enumMainKey, item.status).then(value => {
              item.statusName = value;
              if (index === this.state.list.length - 1) {
                this.forceUpdate();
              }
            });
          }
          if (item.syncStatusName === undefined) {
            EnumService.getValue('B02_Order_Sync_Status', item.syncStatus).then(
              value => {
                item.syncStatusName = value;
                if (index === this.state.list.length - 1) {
                  this.forceUpdate();
                }
              }
            );
          }
        });
        // this.getCompanyParams();
      } else {
        this.setState({
          dataError: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  getCount = function () {
    if (!this.companyCode) {
      return;
    }
    let postbody = {
      apiPath: '/vdeliveryNotice/unFillDnNoCount',
      companyCode: this.companyCode,
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success && response.data) {
        this.setState({ count: response.data });
      }
    });
  };

  handleDnSearch() {
    this.getList();
  }

  submitHandle(e) {
    e.preventDefault();
    e.stopPropagation();
    this.handleReset();
  }

  errorFn(errorMsg) {
    this.errorMsg = errorMsg;
    this.setState({ showLoading: false });
    this.setState({ showError: true });
    this.errorTimer = setTimeout(() => {
      this.setState({ showError: false });
    }, 3000);
  }

  hideDialog() {
    this.setState({
      showIOS2: false,
    });
  }

  handleOrder() {
    this.hideDialog();
    this.setState({ showLoading: true });
    switch (this.type) {
      case 'createIqcOrder':
        this.createIqcOrder(this.currItem);
        break;
      default:
    }
  }

  handle(type, item) {
    switch (type) {
      case 'createIqcOrder':
        this.dialogMsg = '确认新建检验单？';
        break;
      default:
    }
    this.type = type;
    this.currItem = item;
    this.setState({ showIOS2: true });
  }

  // 新建来料检验单 sourceOrderType  1来源送货单 2来源收货单 3入库单(api传)
  createIqcOrder(item) {
    let postbody = {
      sourceXkNo: item.roXkNo,
      companyCode: item.companyCode,
      sourceOrderType: 2,
      apiPath: '/verify/order/create',
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data;
        if (!Util.isEmpty(data)) {
          setTimeout(() => {
            let url;
            if (data.length === 1) {
              url =
                '/mp/purchase/iqc/detail/' + this.companyCode + '/' + data[0];
            } else {
              url = '/mp/purchase/iqc/list';
            }
            this.props.history.push(url);
          }, 500);
        }
      } else {
        this.errorFn(response.errorMsg);
      }
    });
  }

  handleChange(text, e) {
    e.preventDefault();
    this.searchKey = text;
    this.handleReset();
  }

  handleClear() {
    this.searchKey = '';
    this.handleReset();
  }

  handleClearDn() {
    this.searchQueries.dnXkNo = '';
    this.searchQueries.sourceOrderNo = '';
    this.setState({ dnXkNo: '', sourceOrderNo: '' });
    this.handleReset();
  }

  handleNav(index) {
    // this.currNavIndex = index;
    this.setState({ currNavIndex: index });
    this.searchQueries.dnXkNo = '';
    this.searchQueries.sourceOrderNo = '';
    this.setState({ dnXkNo: '', sourceOrderNo: '' });

    switch (index) {
      case 0:
        this.status = undefined;
        this.config = Config['receive'];
        this.setState({ billType: 2 });
        break;
      case 4:
        this.status = [2, 4];
        this.config = Config['receive'];
        this.setState({ billType: 2 });
        break;
      case 1:
        this.status = undefined;
        this.config = Config['storage'];
        this.setState({ billType: 3 });
        break;
      case 41:
        this.status = [2, 4];
        this.config = Config['storage'];
        this.setState({ billType: 3 });
        break;
      default:
        this.status = undefined;
        this.config = Config['receive'];
        this.setState({ billType: 2 });
        break;
    }
    this.handleReset();
  }

  handleReset() {
    this.reset = true;
    this.setState({
      list: [],
    });
    this.pageNum = 1;
    this.setState({ showLoading: true });
    this.getList();
    this.resolveLoading();
  }

  toggleSearch() {
    let isShowsearch = !this.state.isShowSearch;
    this.setState({ isShowSearch: isShowsearch });
  }

  handleNotSync(e) {
    let checked = e.target.checked;
    this.setState({
      onlyShowNotSync: checked,
    });
    setTimeout(() => {
      this.handleReset();
    }, 0);
  }

  render() {
    if (this.state.error !== null) {
      return <Msg {...this.state.error} />;
    }
    return (
      <Page
        transition={false}
        ptr={false}
        className="v2"
        onLoadMore={(resolveLoading, finish) => {
          this.resolveLoading = resolveLoading;
          if (this.state.list.length >= this.total) {
            finish();
          } else {
            this.getList(resolveLoading);
          }
        }}
      >
        <TopNav
          inited={this.state.inited}
          onSubmit={this.handleChange}
          onCancel={this.handleClear}
          onClear={this.handleClear}
          defaultValue={this.searchKey}
          placeholder={this.config.searchBarPlaceholder}
        />
        <Panel>
          {this.state.dataError !== null ? (
            <Msg {...this.state.dataError} />
          ) : (
            <span>
              {this.state.wxReady && (
                <div className="wrap m-flex-box fixed-bottom">
                  {this.state.currNavIndex === 0 && this.state.canReceive && (
                    <Button
                      type="default"
                      onClick={this.scan}
                      className="m-flex-item u-btn u-btn_primary"
                    >
                      <CropFreeIcon fontSize="inherit" />
                      扫码收货
                    </Button>
                  )}
                  {this.state.currNavIndex === 1 && this.state.canStorage && (
                    <Button
                      type="default"
                      onClick={this.scan}
                      className="m-flex-item u-btn u-btn_primary"
                    >
                      <CropFreeIcon fontSize="inherit" />
                      扫码入库
                    </Button>
                  )}
                  {
                    <Button
                      type="default"
                      onClick={this.delivery}
                      className="m-flex-item u-btn u-btn_primary"
                    >
                      <CropFreeIcon fontSize="inherit" />
                      扫码搜索
                    </Button>
                  }
                </div>
              )}

              <div className="m-tab-container">
                <ul className="m-flex-box">
                  {this.tabData
                    .filter(item => {
                      if (typeof item.show === 'function') {
                        return item.show();
                      }
                      return true;
                    })
                    .map((item, index) => (
                      <li
                        key={index}
                        onClick={this.handleNav.bind(this, item.navIndex)}
                        className={
                          this.state.currNavIndex === item.navIndex
                            ? 'm-flex-item curr'
                            : 'm-flex-item'
                        }
                      >
                        <span className="name">{item.label}</span>
                        {item.countIndex && (
                          <i className="u-num">
                            {this.state.count[item.countIndex] || 0}
                          </i>
                        )}
                      </li>
                    ))}
                </ul>
              </div>
              <div>
                {[0, 1].includes(this.state.currNavIndex) && (
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.onlyShowNotSync}
                        onChange={this.handleNotSync}
                        value="checkedA"
                        color="primary"
                      />
                    }
                    labelPlacement="start"
                    label="未同步"
                  />
                )}
                {this.state.currNavIndex === 0 && (
                  <form
                    onSubmit={this.submitHandle.bind(this)}
                    style={{
                      display: 'inline-block',
                      marginLeft: '25px',
                    }}
                  >
                    <span style={{ fontSize: '0.875rem' }}>送货单号</span>
                    <div
                      style={{
                        display: 'inline-block',
                        position: 'relative',
                        marginLeft: '5px',
                      }}
                    >
                      <input
                        name="dnXkNo"
                        value={this.state.dnXkNo}
                        style={{ width: '140px', padding: '5px' }}
                        onChange={event => {
                          this.searchQueries.dnXkNo = event.target.value;
                          this.setState({ dnXkNo: event.target.value });
                        }}
                      />
                      {this.state.dnXkNo !== '' && (
                        <div
                          style={{
                            width: 36,
                            height: '100%',
                            position: 'absolute',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            right: 0,
                            top: 0,
                            opacity: 0.5,
                          }}
                          onClick={this.handleClearDn.bind(this)}
                        >
                          <HighlightOffIcon />
                        </div>
                      )}
                    </div>
                  </form>
                )}
                {this.state.currNavIndex === 1 && (
                  <form
                    onSubmit={this.submitHandle.bind(this)}
                    style={{
                      display: 'inline-block',
                      marginLeft: '25px',
                    }}
                  >
                    <span style={{ fontSize: '0.875rem' }}>来源单据</span>
                    <div
                      style={{
                        display: 'inline-block',
                        position: 'relative',
                        marginLeft: '5px',
                      }}
                    >
                      <input
                        name="sourceOrderNo"
                        value={this.state.sourceOrderNo}
                        style={{ width: '140px', padding: '5px' }}
                        onChange={event => {
                          this.searchQueries.sourceOrderNo = event.target.value;
                          this.setState({ sourceOrderNo: event.target.value });
                        }}
                      />
                      {this.state.sourceOrderNo !== '' && (
                        <div
                          style={{
                            width: 36,
                            height: '100%',
                            position: 'absolute',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            right: 0,
                            top: 0,
                            opacity: 0.5,
                          }}
                          onClick={this.handleClearDn.bind(this)}
                        >
                          <HighlightOffIcon />
                        </div>
                      )}
                    </div>
                  </form>
                )}
              </div>

              <div className="list-total">{this.total}</div>

              {/* 收货单列表 */}
              {[0, 4].includes(this.state.currNavIndex) && (
                <div className="m-details-item">
                  <div className="details-item-content">
                    {this.state.list.map((item, index) => (
                      <span
                        className="content-line line-list-item"
                        key={item.roErpNo}
                      >
                        <div className="line-list-item-title">
                          <span>序号{index + 1}</span>
                          <div className="more">
                            <span
                              className={
                                'u-sign ' +
                                CommonFns.getStatusClass(
                                  'B02_Ro_Status',
                                  item.status
                                )
                              }
                            >
                              {item.statusName}
                            </span>
                            {item.syncStatusName && (
                              <span
                                className={
                                  'u-sign f-ml10 ' +
                                  CommonFns.getStatusClass(
                                    'sync',
                                    item.syncStatus
                                  )
                                }
                              >
                                {item.syncStatusName}
                              </span>
                            )}
                          </div>
                        </div>
                        <ul className="field-list">
                          <li>
                            <label>供应商</label>
                            <div>
                              {item.innerVendorName}({item.innerVendorCode})
                            </div>
                          </li>
                          <li>
                            <label>送货通知单号</label>
                            <div>{item.dnXkNo}</div>
                          </li>
                          <li>
                            <label>收货单号</label>
                            <div>
                              <Link
                                to={`${this.config.detailLink}/${this.companyCode}/${item.roXkNo}`}
                              >
                                {item.roErpNo}
                              </Link>
                            </div>
                          </li>
                          <li>
                            <label>收货日期</label>
                            <div>{formatDate(item.erpReceiveDate)}</div>
                          </li>
                          <li>
                            <label>发布人</label>
                            <div>{item.publishName}</div>
                          </li>
                        </ul>

                        {/* 送检 */}
                        {User.checkAuth('10080102') &&
                          this.state.canRreateIqcOrder &&
                          [1, 3].indexOf(item.status) !== -1 &&
                          [0, 1].includes(item.sendVerifyStatus) &&
                          ((item.syncStatus === 2 && item.sourceSystem === 1) ||
                            item.sourceSystem === 2) && (
                            <div className="footer m-flex-box m-flex-item">
                              <Button
                                className={'m-flex-item u-btn'}
                                onClick={() => {
                                  this.handle('createIqcOrder', item);
                                }}
                              >
                                送检
                              </Button>
                            </div>
                          )}
                      </span>
                    ))}

                    {!this.state.showLoading &&
                      this.state.list.length === 0 && (
                        <LoadMore showLine> 暂无数据</LoadMore>
                      )}
                  </div>
                </div>
              )}

              {/* 入库单列表 */}
              {[1, 41].includes(this.state.currNavIndex) && (
                <div className="m-details-item">
                  <div className="details-item-content">
                    {this.state.list.map((item, index) => (
                      <span
                        className="content-line line-list-item"
                        key={item.stoXkNo}
                      >
                        <div className="line-list-item-title">
                          <span>序号{index + 1}</span>
                          <div className="more">
                            <span
                              className={
                                'u-sign ' +
                                CommonFns.getStatusClass(
                                  'B02_Sto_Status',
                                  item.status
                                )
                              }
                            >
                              {item.statusName}
                            </span>
                            {item.syncStatusName && (
                              <span
                                className={
                                  'u-sign f-ml10 ' +
                                  CommonFns.getStatusClass(
                                    'sync',
                                    item.syncStatus
                                  )
                                }
                              >
                                {item.syncStatusName}
                              </span>
                            )}
                          </div>
                        </div>
                        <ul className="field-list">
                          <li>
                            <label>供应商</label>
                            <div>
                              {item.innerVendorName}({item.innerVendorCode})
                            </div>
                          </li>
                          <li>
                            <label>来源单号</label>
                            <div>
                              {
                                item[
                                  this.config.docNumKey[item.sourceOrderType]
                                ]
                              }
                            </div>
                          </li>
                          <li>
                            <label>入库单号</label>
                            <div>
                              <Link
                                to={`${this.config.detailLink}/${this.companyCode}/${item.stoXkNo}`}
                              >
                                {item.stoErpNo}
                              </Link>
                            </div>
                          </li>
                          <li>
                            <label>入库日期</label>
                            <div>{formatDate(item.erpStorageDate)}</div>
                          </li>
                        </ul>
                      </span>
                    ))}

                    {!this.state.showLoading &&
                      this.state.list.length === 0 && (
                        <LoadMore showLine> 暂无数据</LoadMore>
                      )}
                  </div>
                </div>
              )}
            </span>
          )}
        </Panel>

        {this.state.companyCode &&
          this.state.billType &&
          this.state.dnDetail?.id && (
            <DeliveryToReceive
              companyCode={this.state.companyCode}
              billType={this.state.billType}
              detail={this.state.dnDetail}
              onChange={this.handleConvertChange}
            ></DeliveryToReceive>
          )}
        <Dialog
          type="ios"
          title={this.state.style2.title}
          buttons={this.state.style2.buttons}
          show={this.state.showIOS2}
        >
          {this.dialogMsg}
        </Dialog>
        <Toast icon="loading" show={this.state.showLoading}>
          数据加载中...
        </Toast>

        <Toast icon="success-no-circle" show={this.state.showSuccess}>
          操作成功
        </Toast>
      </Page>
    );
  }
}

ReceiveList.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.login,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ReceiveList));
